module.exports = __webpack_public_path__ + "static/media/2b.d41f8685.jpg";